/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSyncBudgets extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSyncBudgets");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSyncBudgets.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSyncBudgets>): BackgroundJobPayloadForPeriodicSyncBudgets {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSyncBudgets(), model);
        BackgroundJobPayloadForPeriodicSyncBudgets.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSyncBudgets>): BackgroundJobPayloadForPeriodicSyncBudgets {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSyncBudgets.newInstance(<BackgroundJobPayloadForPeriodicSyncBudgets> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSyncBudgets) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSyncBudgets.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSyncBudgets): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSyncBudgets.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
